import $http from '@/api/index'
// 添加、编辑机构类型
export function AddOrUpdateCompanyType(params) {
  let options = {
    method: 'POST',
    url: 'emergencybasedata/AddOrUpdateCompanyType',
    requestType: 11
  }
  return $http(options, params);
}
// 机构类型判断名称和code是否重复
export function JudgeCompanyTypeExistNameorCode(params) {
  let options = {
    method: 'GET',
    url: 'emergencybasedata/JudgeCompanyTypeExistNameorCode',
    requestType: 11
  }
  return $http(options, params)
}
// 判断手机号和工号
export function VerifyUserCodeAndPhone(params) {
  let options = {
    method: 'GET',
    url: 'emergencybasedata/VerifyUserCodeAndPhone',
    requestType: 11
  }
  return $http(options, params)
}
// 机构类型列表
export function GetAllCompanyTypeBySearchPara(params) {
  let options = {
    method: 'GET',
    url: 'emergencybasedata/GetAllCompanyTypeBySearchPara',
    requestType: 11
  }
  return $http(options, params)
}
// 删除机构类型
export function DeleteCompanyTypeById(params) {
  let options = {
    method: 'POST',
    url: 'emergencybasedata/DeleteCompanyTypeById',
    requestType: 11,
    isParams: true
  }
  return $http(options, params)
}